// @ts-nocheck

import "./DraggableTableRow.st.css.js";
import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "DragHandle1363796532";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"DragHandle1363796532__root","triggerIcon":"DragHandle1363796532__triggerIcon","trigger":"DragHandle1363796532__trigger"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-table-list-item-drag-handle-color":"--wds-table-list-item-drag-handle-color","wds-table-list-item-drag-handle-color-hover":"--wds-table-list-item-drag-handle-color-hover","wds-color-blue-300":"--wds-color-blue-300"}; 




